
import React,{ lazy, useEffect } from 'react';
import LazySection from 'components/lazySection';
import SectionSkeleton from './sectionskeleton';
const UtilityProject = lazy(() => import("components/Utility/UtilityProject"));
const UtilityBanner = lazy(() => import("components/Utility/UtilityBanner"));
const UtilityImpactScale = lazy(() => import("components/Utility/UtilityImpactScale"));
const UtilityKeyStrength = lazy(() => import("components/Utility/UtilityKeyStrength"));



const Utility: React.FC = () => {
  useEffect(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // or "smooth"
      });
  }, []);
  return (
    <>
      <UtilityBanner/>
   

      {/* Lazy load sections when visible */}
        <LazySection fallback={<SectionSkeleton height={400} />}>
            <UtilityKeyStrength />
        </LazySection>

        <LazySection fallback={<SectionSkeleton height={400} />}>
            <UtilityImpactScale />
        </LazySection>

        <LazySection fallback={<SectionSkeleton height={400} />}>
            <UtilityProject />
        </LazySection>

       
    </>
  );
};

export default Utility;
